import React from 'react'
import ProjectItem from './ProjectItem'
import MedonateImg from '../assets/Medonate.png'
import verifyMe from '../assets/VerifyMe.jpeg'

const Projects = () => {
  return (
    <div id = 'projects' className = "w-full">
      <div className = "max-w-[1240px] mx-auto px-2 py-16">
          <div className = "flex justify-center items-center">
          <p className = "text-4xl tracking-widest text-[#5651e5] pb-12">PROJECTS </p>
          </div>
          <div className = "grid md:grid-cols-2 gap-8">
              <ProjectItem title = "MEDONATE" backgroundImg = {MedonateImg} projectUrl = "https://github.com/Modernbeast02/Medonate-"/>
              <ProjectItem title = "VERIFY-ME" backgroundImg = {verifyMe} projectUrl = "https://github.com/Modernbeast02/verifyme"/>
          </div>
      </div>
    </div>
  )
}

export default Projects
